module.exports = __webpack_public_path__ + "img/katarina_outside_24.c0a9310a.jpg";